@if (isInitSuccessfully) {
  @if (!isLoginActive) {
    @if (!isAdminActive) {
      <app-nav-header
      [expertisesList]="expertisesList"></app-nav-header>
    }
  }
  <router-outlet></router-outlet>
  @if (!isAdminActive) {
    <app-footer></app-footer>
  }
}
<div [ngClass]="{ fade: isAnimationProcessActive }">
  <div
    class="logo-container absolute h-[100vh] w-[100%] flex justify-center items-center"
    [ngClass]="{ 'fade-out': isFadeOut, 'fade-in': !isFadeOut }">
    <div class="relative flex justify-center items-center w-full h-full">
      <canvas
        #canvas
      class="lg:w-[30%] lg:h-[40%] md:w-[40%] md:h-[40%] sm:w-[40%] sm:h-[50%] w-[90%] h-[90%]"></canvas>
    </div>
  </div>
</div>
